import { ExpiredSessionMessages, TranslationExpiredSessionMessages } from "../interfaces/expiredSessionMessages";

export const messages: TranslationExpiredSessionMessages = {
  [ExpiredSessionMessages.formDialogTitle]: "Your session has expired!",
  [ExpiredSessionMessages.formDialogContent]: "Re-login with your login user to continue using the system safely",
  [ExpiredSessionMessages.formDialogActionText]: "Go to login page"
};
